import { dataHooks } from '../../../libs/dataHooks';

export const appDataHooks = dataHooks<{
  headerMenuPanel: {};
  headerTitle: {};
  templatesPage: {};
  seoSection: {};
}>('app');
